import './components/Modernizr';
import './components/DisableFormZoom';
import './classes/MobileMenu';
import './classes/ObjectFit';
import './classes/Accordions';
import './classes/TouchDropdown';
